/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { Extension } from 'tiptap';

export default class CustomKeys extends Extension {
  keys() {
    const options = this.options;

    const emitEvent = (event, args = {}) => {
      if (options[event] && typeof options[event] === 'function') {
        options[event](args);
      }
    };
    return {
      'Shift-Enter'() {
        emitEvent('onShiftEnter');
        return true;
      },
    };
  }
}
